<template>
    <div class="message" :style="{'overflow-y': open ? 'scroll' : 'hidden'}" ref="cc" @scroll="scrollHandler($event)">
        <div v-if="quan" style="height: 100%;display: flex;justify-content: center;align-items: center;">
            <i style="font-size: 50px;" class="el-icon-loading"></i>
        </div>
            <!-- <el-form-item label="备注">
                        <el-input
                            type="textarea"
                            placeholder="备注"
                            :rows="2"
                            v-model="chatLists"
                            size="small"
                        ></el-input>
                    </el-form-item> -->
            <ul v-else>
                <!-- <li v-for="entry in chatLists">
                    <p class="time">
                        <span>{{ entry.createTime | time }}</span>
                    </p>
                    <div class="main" :class="{ self: entry.receiver.id == user.senderId }">
                        <p :class="entry.receiver.id == user.senderId ? 'usernameright' : 'usernameleft'">{{ entry.receiver.id == user.id?entry.receiver.userNickname : entry.sender.userNickname }}</p>
                        <img class="avatar" :src="entry.receiver.id == user.id?entry.receiver.userHeader : entry.sender.userHeader" alt="" />
                        <span v-if="entry.receiver.id == user.senderId" style="font-size: 12px;margin-right: 4px;">{{ entry.isOffline != 1 ? '未读' : '已读' }}</span>
                        <div v-if="entry.messageType == 1 && /<img[^>]+>/g.test(entry.messageContent) == false" class="text">{{ entry.messageContent }}</div>
                        <div v-if="entry.messageType == 1 && /<img[^>]+>/g.test(entry.messageContent) == true" class="text" v-html="entry.messageContent"></div>
                        <el-image v-if="entry.messageType == 2" @click='updateSrcList(entry.messageContent)' class="img"
                            :src="entry.messageContent" :preview-src-list="srcList"> </el-image>
                    </div>
                </li> -->
                <li v-if="reset && page.pageNum < pages">
                    <div style="text-align: center;">
                        <i class="el-icon-loading"></i>
                    </div>
                </li>
                <li v-for="entry in chatLists">
                    <div :class="entry.senderId == user.senderId ? 'messageitem' : 'messageitem1'">
                        <div class="time">
                            <span>{{ entry.createTime | time }}</span>
                        </div>
                        <p class="usernameright">{{ entry.senderId == sender.senderId ? sender.nickName : receiver.nickName }}</p>
                        <div class="avtorimg">
                            <img class="avatar" :src="entry.senderId == sender.senderId ? sender.headImage : receiver.headImage" alt="" />
                            <div class="content">
                                <div @click="OnCheckStatus(entry)" v-if="entry.senderId != user.senderId" :style="{'font-size': '12px','margin-right': '4px','width': '80px','display': 'flex','align-items': 'end','justify-content': 'end','color': entry.isSend == 3 ? 'red' : 'black','cursor': entry.isSend == 3 ? 'pointer': ''}">{{ checkStatus(entry.isSend) }}</div>
                                <div class="constmer">
                                    <!-- <span v-if="entry.messageType == 1 && /<img[^>]+>/g.test(entry.messageContent) == false && false" class="text">{{ entry.messageContent }}</span> -->
                                    <pre class="text" v-if="entry.messageType == 1" v-html="churst(entry.messageContent)"></pre>
                                    <el-image v-if="entry.messageType == 2" @click='updateSrcList(entry.messageContent)' class="img"
                                        :src="entry.messageContent" :preview-src-list="srcList"> </el-image>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <div v-if="Mute && !quan" class="jinyan">
                <span>你被禁言了</span>
            </div>
            <div v-if="loggedIn && !quan && nextxq" class="jinyan">
                <span>账号已在其他地方登录,请重新登录！</span>
            </div>
            <div v-if="isNetworkError && !quan" class="jinyan">
                <span>连接已断开,请刷新页面</span>
            </div>
    </div>
        <!-- <div>
            <ul>
                <li v-for="entry in sessions['群聊']" :key="entry.id">
                    <p class="time">
                        <span>{{ entry.createTime | time }}</span>
                    </p>
                    <div class="main" :class="{ self: entry.fromId == user.id }">
                        <p class="username">{{ entry.fromName }}</p>
                        <img
                            @dblclick="takeAShot"
                            class="avatar"
                            :src="entry.fromId == user.id ? user.userProfile : entry.fromProfile"
                            alt=""
                        />
                        <div v-if="entry.messageTypeId == 1"><p class="text" v-html="entry.content"></p></div>
                        <div v-else>
                            <el-image :src="entry.content" :preview-src-list="[entry.content]" class="img">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </div>
                    </div>
                </li>
            </ul>
        </div> -->
</template>

<script>
import { mapState } from 'vuex';
import { get } from '@/utils/request'; 
import socketObj from '@/utils/socket/socket_methods.js'
import CircularJSON from 'circular-json';
export default {
    name: 'message',
    data() {
        return {
            user: {},
            faceList: [  //表情包数据
                {
                    "url": "100.gif",
                    alt: "face[微笑]"
                }, {
                    "url": "101.gif",
                    alt: "face[伤心]"
                }, {
                    "url": "102.gif",
                    alt: "face[美女]"
                }, {
                    "url": "103.gif",
                    alt: "face[发呆]"
                }, {
                    "url": "104.gif",
                    alt: "face[墨镜]"
                }, {
                    "url": "105.gif",
                    alt: "face[哭]"
                }, {
                    "url": "106.gif",
                    alt: "face[羞]"
                }, {
                    "url": "107.gif",
                    alt: "face[哑]"
                }, {
                    "url": "108.gif",
                    alt: "face[睡]"
                }, {
                    "url": "109.gif",
                    alt: "face[哭]"
                }, {
                    "url": "110.gif",
                    alt: "face[囧]"
                }, {
                    "url": "111.gif",
                    alt: "face[怒]"
                }, {
                    "url": "112.gif",
                    alt: "face[调皮]"
                }, {
                    "url": "113.gif",
                    alt: "face[笑]"
                }, {
                    "url": "114.gif",
                    alt: "face[惊讶]"
                }, {
                    "url": "115.gif",
                    alt: "face[难过]"
                }, {
                    "url": "116.gif",
                    alt: "face[酷]"
                }, {
                    "url": "117.gif",
                    alt: "face[汗]"
                }, {
                    "url": "118.gif",
                    alt: "face[抓狂]"
                }, {
                    "url": "119.gif",
                    alt: "face[吐]"
                }, {
                    "url": "120.gif",
                    alt: "face[笑]"
                }, {
                    "url": "121.gif",
                    alt: "face[快乐]"
                }, {
                    "url": "122.gif",
                    alt: "face[奇]"
                }, {
                    "url": "123.gif",
                    alt: "face[傲]"
                },
                {
                    "url": "124.gif",
                    alt: "face[饿]"
                }, {
                    "url": "125.gif",
                    alt: "face[累]"
                }, {
                    "url": "126.gif",
                    alt: "face[吓]"
                }, {
                    "url": "127.gif",
                    alt: "face[汗]"
                }, {
                    "url": "128.gif",
                    alt: "face[高兴]"
                }, {
                    "url": "129.gif",
                    alt: "face[闲]"
                }, {
                    "url": "130.gif",
                    alt: "face[努力]"
                }, {
                    "url": "131.gif",
                    alt: "face[骂]"
                }, {
                    "url": "132.gif",
                    alt: "face[疑问]"
                }, {
                    "url": "133.gif",
                    alt: "face[秘密]"
                }, {
                    "url": "134.gif",
                    alt: "face[乱]"
                }, {
                    "url": "135.gif",
                    alt: "face[疯]"
                }, {
                    "url": "136.gif",
                    alt: "face[哀]"
                }, {
                    "url": "137.gif",
                    alt: "face[鬼]"
                }, {
                    "url": "138.gif",
                    alt: "face[打击]"
                }, {
                    "url": "139.gif",
                    alt: "face[bye]"
                }, {
                    "url": "140.gif",
                    alt: "face[汗]"
                }, {
                    "url": "141.gif",
                    alt: "face[抠]"
                }, {
                    "url": "142.gif",
                    alt: "face[鼓掌]"
                }, {
                    "url": "143.gif",
                    alt: "face[糟糕]"
                }, {
                    "url": "144.gif",
                    alt: "face[恶搞]"
                }, {
                    "url": "145.gif",
                    alt: "face[什么]"
                }, {
                    "url": "146.gif",
                    alt: "face[什么]"
                }, {
                    "url": "147.gif",
                    alt: "face[累]"
                },
                {
                    "url": "148.gif",
                    alt: "face[看]"
                }, {
                    "url": "149.gif",
                    alt: "face[难过]"
                }, {
                    "url": "150.gif",
                    alt: "face[难过]"
                }, {
                    "url": "151.gif",
                    alt: "face[坏]"
                }, {
                    "url": "152.gif",
                    alt: "face[亲]"
                }, {
                    "url": "153.gif",
                    alt: "face[吓]"
                }, {
                    "url": "154.gif",
                    alt: "face[可怜]"
                }, {
                    "url": "155.gif",
                    alt: "face[刀]"
                }, {
                    "url": "156.gif",
                    alt: "face[水果]"
                }, {
                    "url": "157.gif",
                    alt: "face[酒]"
                }, {
                    "url": "158.gif",
                    alt: "face[篮球]"
                }, {
                    "url": "159.gif",
                    alt: "face[乒乓]"
                }, {
                    "url": "160.gif",
                    alt: "face[咖啡]"
                }, {
                    "url": "161.gif",
                    alt: "face[美食]"
                }, {
                    "url": "162.gif",
                    alt: "face[动物]"
                }, {
                    "url": "163.gif",
                    alt: "face[鲜花]"
                }, {
                    "url": "164.gif",
                    alt: "face[枯]"
                }, {
                    "url": "165.gif",
                    alt: "face[唇]"
                }, {
                    "url": "166.gif",
                    alt: "face[爱]"
                }, {
                    "url": "167.gif",
                    alt: "face[分手]"
                }, {
                    "url": "168.gif",
                    alt: "face[生日]"
                }, {
                    "url": "169.gif",
                    alt: "face[电]"
                }, {
                    "url": "170.gif",
                    alt: "face[炸弹]"
                }, {
                    "url": "171.gif",
                    alt: "face[刀子]"
                },
                {
                    "url": "172.gif",
                    alt: "face[足球]"
                }, {
                    "url": "173.gif",
                    alt: "face[瓢虫]"
                }, {
                    "url": "174.gif",
                    alt: "face[翔]"
                }, {
                    "url": "175.gif",
                    alt: "face[月亮]"
                }, {
                    "url": "176.gif",
                    alt: "face[太阳]"
                }, {
                    "url": "177.gif",
                    alt: "face[礼物]"
                }, {
                    "url": "178.gif",
                    alt: "face[抱抱]"
                }, {
                    "url": "179.gif",
                    alt: "face[拇指]"
                }, {
                    "url": "180.gif",
                    alt: "face[贬低]"
                }, {
                    "url": "181.gif",
                    alt: "face[握手]"
                }, {
                    "url": "182.gif",
                    alt: "face[剪刀手]"
                }, {
                    "url": "183.gif",
                    alt: "face[抱拳]"
                }, {
                    "url": "184.gif",
                    alt: "face[勾引]"
                }, {
                    "url": "185.gif",
                    alt: "face[拳头]"
                }, {
                    "url": "186.gif",
                    alt: "face[小拇指]"
                }, {
                    "url": "187.gif",
                    alt: "face[拇指八]"
                }, {
                    "url": "188.gif",
                    alt: "face[食指]"
                }, {
                    "url": "189.gif",
                    alt: "face[ok]"
                }, {
                    "url": "190.gif",
                    alt: "face[情侣]"
                }, {
                    "url": "191.gif",
                    alt: "face[爱心]"
                }, {
                    "url": "192.gif",
                    alt: "face[蹦哒]"
                }, {
                    "url": "193.gif",
                    alt: "face[颤抖]"
                }, {
                    "url": "194.gif",
                    alt: "face[怄气]"
                }, {
                    "url": "195.gif",
                    alt: "face[跳舞]"
                },
                {
                    "url": "196.gif",
                    alt: "face[发呆]"
                }, {
                    "url": "197.gif",
                    alt: "face[背着]"
                }, {
                    "url": "198.gif",
                    alt: "face[伸手]"
                }, {
                    "url": "199.gif",
                    alt: "face[耍帅]"
                }, {
                    "url": "200.png",
                    alt: "face[微笑]"
                }, {
                    "url": "201.png",
                    alt: "face[生病]"
                }, {
                    "url": "202.png",
                    alt: "face[哭泣]"
                }, {
                    "url": "203.png",
                    alt: "face[吐舌]"
                }, {
                    "url": "204.png",
                    alt: "face[迷糊]"
                }, {
                    "url": "205.png",
                    alt: "face[瞪眼]"
                }, {
                    "url": "206.png",
                    alt: "face[恐怖]"
                }, {
                    "url": "207.png",
                    alt: "face[忧愁]"
                }, {
                    "url": "208.png",
                    alt: "face[眨眉]"
                }, {
                    "url": "209.png",
                    alt: "face[闭眼]"
                }, {
                    "url": "210.png",
                    alt: "face[鄙视]"
                }, {
                    "url": "211.png",
                    alt: "face[阴暗]"
                }, {
                    "url": "212.png",
                    alt: "face[小鬼]"
                }, {
                    "url": "213.png",
                    alt: "face[礼物]"
                }, {
                    "url": "214.png",
                    alt: "face[拜佛]"
                }, {
                    "url": "215.png",
                    alt: "face[力量]"
                }, {
                    "url": "216.png",
                    alt: "face[金钱]"
                }, {
                    "url": "217.png",
                    alt: "face[蛋糕]"
                }, {
                    "url": "218.png",
                    alt: "face[彩带]"
                }, {
                    "url": "219.png",
                    alt: "face[礼物]"
                }, 
			],
            page:{
                pageSize: 15,
                pageNum: 1
            },
            resultList:[],
            reset: false,
            jinyan: false,
            pages:0,
            chatLists:[],
            checkPage: false,
            isFrist: true,
            count:0,
            onFack:false,
            quan: false,
            currentTop:0,
            open: false,
            connect1: false,
            srcList: [''],
            nextxq: false,
            sender:{},
            receiver:{}
            // sessions: {}
            // currentSession: { username: '群聊', nickname: '群聊' } //当前选中的用户，默认为群聊
            // errorImgUrl: 'http://39.108.169.57/group1/M00/00/00/J2ypOV7wJkyAAv1fAAANuXp4Wt8303.jpg' //错误提示图片
            // user: JSON.parse(window.sessionStorage.getItem('user'))
        };
    },
    computed: { ...mapState('chat', ['sessions', 'currentSession', 'errorImgUrl']) ,
    ...mapState('newChat',['chatListss','socketTask','userInfo']),
        chatUserInfo(){
            return this.$store.state.newChat.chatUserInfo;
        },
        Mute(){
            // console.log(this.$store.state.newChat.Mute);
            return this.$store.state.newChat.Mute;
        },
        loggedIn(){
            // console.log(this.$store.state.newChat.loggedIn);
            return this.$store.state.newChat.loggedIn;
        },
        isNetworkError(){
            // console.log(this.$store.state.newChat.isNetworkError);
            return this.$store.state.newChat.isNetworkError;
        }
    },
    created(){
        this.$store.commit('newChat/setChatUserInfo',{});
        this.$store.commit('newChat/setMute', false);
        // this.$store.commit('newChat/setIsLoggedIn', false);
        // this.$store.commit('newChat/setIsNetworkError', false);
        this.connect1 = false;
        // console.log(this.quan,"???",this.loggedIn);
        this.$store.commit('newChat/setOnReceiveEventFun',this.changeStatus)
        this.sender = JSON.parse(localStorage.getItem('sender'))
    },
    watch:{
        chatUserInfo(aa){
            this.user = aa;
            // console.log(aa)
            this.page.pageNum = 1;
            this.chatLists = [];
            this.isFrist = true;
            this.jinyan = false;
            this.pages = 0
            if(JSON.stringify(aa) == '{}'){
                return
            }
            if(this.chatUserInfo.senderId){
                this.open = true
            }else{
                this.open = false
            }
            if(this.loggedIn){
                this.nextxq = true;
            }else{
                this.nextxq = false;
            }
            this.reset = false;
            let userInfoCate = CircularJSON.parse(localStorage.getItem(`msgList_${this.userInfo.id}_${this.user.senderId}`))
            let resultList = userInfoCate.msgList;
            this.receiver = userInfoCate.receiver;
            this.pages = Math.ceil(resultList.length/this.page.pageSize)
            resultList.reverse()
            this.resultList = resultList;
            this.quan = true;
            this.getChatList()
        },
        chatListss(aa){
            // console.log("信息请")
            // console.log(aa)
            // console.log(this.chatLists)
            // console.log(this.userInfo)
            if(aa == 'ChatUserInfoOfDelete'){
                this.chatLists = [];
                this.jinyan = false;
                return
            }else if(typeof aa == 'string'){
                // console.log("已读多少")
                // 将拼接的字符串分割成数组
                let idsArray = aa.split(',');
                // console.log(idsArray,'没有进来')
                // 根据ID在数组中查找对应的对象，并修改其属性值
                idsArray.forEach(id => {
                    let foundObject = this.chatLists.find(obj => obj.messageId == id);
                    // console.log(foundObject,'123')
                    if (foundObject) {
                        foundObject.isSend = 2;
                    }
                });
                let objs = CircularJSON.parse(localStorage.getItem(`msgList_${this.userInfo.id}_${this.chatUserInfo.senderId}`))
                let arrays = objs.msgList;
                idsArray.forEach((id)=>{
                    let foundObject = arrays.find(obj => obj.messageId == id);
                    // console.log(foundObject,'456')
                    if (foundObject) {
                        foundObject.isSend = 2;
                    }
                })
                objs.msgList = arrays;
                localStorage.setItem(`msgList_${this.userInfo.id}_${this.chatUserInfo.senderId}`,CircularJSON.stringify(objs))
                this.jinyan = false;
                return
            }
            if(aa.messageId){
                this.chatLists.push(aa)
                // console.log("我时间塞");
            }else{
                return;
            }
            if(aa.senderId == this.userInfo.id){
                // console.log("我发的")
                this.onFack = true;
                this.jinyan = false;
            }else{
                // console.log("别人发的")
                this.onFack = true
                get(`/mpp/utils/getMessageId`).then((res)=>{
                        if(res.success){
                            let obj = {
                                senderId: this.userInfo.id,
                                receiverId: this.chatUserInfo.senderId,
                                message: aa.messageId,
                                messageId: res.messageId
                            }
                            let msgobj = socketObj.signed(obj)
                            if(!this.socketTask){
                                // this.$message.error('已掉线')
                                this.content = '';
                                return
                            }
                            this.socketTask.send(msgobj)
                            // console.log(msgobj)
                            // 修改缓存已读
                            let objs = CircularJSON.parse(localStorage.getItem(`msgList_${this.userInfo.id}_${this.chatUserInfo.senderId}`))
                            let array = objs.msgList
                            for (let iterator of array) {
                                if(iterator.messageId == aa.messageId){
                                    iterator.isSend = 2;
                                    break;
                                }
                            }
                            objs.msgList = array;
                            localStorage.setItem(`msgList_${this.userInfo.id}_${this.chatUserInfo.senderId}`,CircularJSON.stringify(objs))
                            // console.log("他人在线且在当前聊天页面，直接回复已读")
                        }
                    }).catch(()=>{
                        this.connect1 = true;
                    })
                    this.jinyan = false;
            }
        },
        checkPage(val,old){
            if(val == true && val != old){
                if(this.page.pageNum < this.pages){
                    this.page.pageNum++
                    this.getChatList()
                }
            }
        },
        chatLists(){
            // console.log("变化")
        }
    },
    mounted() {
        // console.log(this.sessions);
        // console.log(this.chatList)
        // console.log(this.currentSession);
        // console.log(this.errorImgUrl);
        // console.log(this.user.username + '#' + this.currentSession.username);
        this.$refs.cc.addEventListener('scroll', this.scrollHandler, true);
        // console.log(this.socketTask.send(`{"actionType":3,"deviceType":1,"message":{"messageType":1,"senderId":"a2d3fb4d79714871b00f8535efd84e94","receiverId":"b4b9efbb8e974b129f854dd1f2adf036","message":"hello","messageId":"4d79714871b"}}`))
    },
    beforeUpdate(){
        this.currentTop = this.$refs.cc.scrollHeight-this.$refs.cc.scrollTop;
    },
    updated(){
        if(!this.onFack){
            this.$refs.cc.scrollTop = this.$refs.cc.scrollHeight - this.currentTop;
        }else{
            this.$refs.cc.scrollTop = this.$refs.cc.scrollHeight;
            this.onFack = false;
        }
    },
    beforeDestroy(){
        this.$store.commit('newChat/setChatUserInfo',{})
        this.$store.commit('newChat/setChatListss',[])
    },
    filters: {
        time(date) {
            if (date) {
                date = new Date(date);
            }
            //当前的时间
            let currentDate = new Date();
            //与当前时间的日期间隔
            let timeInterval = Math.floor((new Date(currentDate.toDateString()).getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
            //星期数组
            let weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            //时间范围
            // let timeRange = '上午';
            // if (date.getHours() > 12) {
            //     timeRange = '下午';
            // }
            //如果与当前时间同日
            if (date.getMonth() == currentDate.getMonth() && date.getDate() == currentDate.getDate()) {
                return `${date.getHours()}:${date.getMinutes()<10 ? '0' + date.getMinutes() : date.getMinutes()}`;
            }
            //在当前时间同一年且日期间隔在7天内
            if (date.getFullYear() == currentDate.getFullYear() && timeInterval <= 5 && timeInterval >= 0) {
                //当前时间的前一天
                if (timeInterval == 10) {
                    return `昨天 ${date.getHours()}:${date.getMinutes()<10 ? '0' + date.getMinutes() : date.getMinutes()}`;
                } else {
                    return `${weekdays[date.getDay()]} ${date.getHours()}:${date.getMinutes()<10 ? '0' + date.getMinutes() : date.getMinutes()}`;
                }
            }
            //如果日期超过7天
            else
                return `${date.getFullYear()}-${
                    date.getMonth() + 1
                }-${date.getDate()} ${date.getHours()}:${date.getMinutes()<10 ? '0' + date.getMinutes() : date.getMinutes()}`;
        }
    },
    directives: {
        /*这个是vue的自定义指令,官方文档有详细说明*/
        // 发送消息后滚动到底部,这里无法使用原作者的方法，也未找到合理的方法解决，暂用setTimeout的方法模拟
        'scroll-bottom'(el) {
            // console.log(el);
            setTimeout(function () {
                el.scrollTop += 9999;
            }, 1);
        }
    },
    methods: {
        updateSrcList(src){
            this.srcList[0] = src
        },
        // 判断信息状态
        checkStatus(message){
            if(message == 0){
                return '正在发送中'
            }else if(message == 1){
                return '未读'
            }else if(message == 2){
                return '已读'
            }else if(message == 3){
                return '发送失败'
            }
        },
        OnCheckStatus(item){
            if(item.isSend == 3){
                // console.log(item,'要重发');
                let obj = {
                    senderId: item.senderId,
                    receiverId: this.chatUserInfo.senderId,
                    message: item.messageContent,
                    messageId: item.messageId
                }
                let msgobj = ''
                if(item.messageType == 1){
                    msgobj = socketObj.privateChat(obj)
                }else if(item.messageType == 2){
                    msgobj = socketObj.packImageMessage(obj)
                }
                if(!this.socketTask){
                    this.changeStatus({messageId: item.messageId,state: 3})
                    // this.$message.error('已掉线')
                    return
                }
                this.socketTask.send(msgobj)
                let objs = {...obj,isSend: 0,messageContent:item.messageContent,  messageType: item.messageType,createTime: new Date().getTime()}
                this.$store.dispatch('newChat/notOnLine',objs)
                // console.log(msgobj)
            }
        },
        churst(processedMessage){
            this.faceList.forEach(emoji => {
                let str = emoji.alt
                let result = str.replace(/face\[/g, ''); // 使用正则表达式匹配方括号及其内容，替换为空字符串
                result = result.replace(/\]/g, ''); // 使用正则表达式匹配方括号及其内容，替换为空字符串
                // console.log(result)
                let altPattern = new RegExp(emoji.alt.replace(/(face\[(.*?)\])/g, 'face\\[$2\\]'), 'g');
                // console.log(altPattern)
                // console.log(altPattern,emoji,processedMessage.replace(altPattern, `<img src="${emoji.url}" alt="${result}">`))
                processedMessage = processedMessage.replace(altPattern, `<img style="display: inline-block;width: 20px;height: 20px;" src="${this.getImageSrc(emoji.url)}" alt="${result}">`);
            });
            return processedMessage;
            // let altPattern = new RegExp(/face\[(.*?)\]/g);
            // console.log(altPattern,emoji,processedMessage.replace(altPattern, `<img src="${emoji.url}" alt="${result}">`))
            // val = val.replace(altPattern, `<img style="display: inline-block;width: 20px;height: 20px;" class="custom-img" src="${this.getImageSrc(emoji.url)}" alt="${result}">`);
            // return val;
        },
        getImageSrc(url) {
            return require(`@/assets/img/emoji/${url}`);
        },
        takeAShot(fromName, toName) {
            // console.log('拍了一怕');
            let s = fromName + '拍了拍' + toName;
        },
        // getChatList(){
        //     console.log(this.user)
        //     let obj = {
        //         ...this.page,
        //         friendUserId: this.user.senderId
        //     }
        //     get(`/im/friendmessage/findChatList`,obj).then((res)=>{
        //         console.log(res)
        //         if(res.success){
        //             let array = res.page.list
        //             array.reverse()
        //             // 收集id，消息已读
        //             let resultString = array
        //             .filter(obj => obj.senderUserId == this.chatUserInfo.senderId) // 过滤条件，排除key为空的对象
        //             .map(obj => obj.messageId)
        //             .join(',');
        //             console.log(resultString,array,this.chatUserInfo.senderId)
        //             if(resultString != ''){
        //                 get(`/mpp/utils/getMessageId`).then((res)=>{
        //                     if(res.success){
        //                         let obj = {
        //                             senderId: this.userInfo.id,
        //                             receiverId: this.chatUserInfo.senderId,
        //                             message: resultString,
        //                             messageId: res.messageId
        //                         }
        //                         let msgobj = socketObj.signed(obj)
        //                         if(!this.socketTask){
        //                             this.$message.error('已掉线')
        //                             this.content = '';
        //                             return
        //                         }
        //                         this.socketTask.send(msgobj)
        //                         console.log(msgobj)
        //                         //清空输入框
        //                         // this.content = '';
        //                     }
        //                 }).catch(()=>{
        //                     this.connect1 = true;
        //                 })
        //             }
        //             this.chatLists = [...array,...this.chatLists]
        //             console.log(this.user)
        //             this.pages = res.page.pages
        //             this.checkPage = false
        //             this.quan = false
        //             this.reset = false
        //         }
        //     })
        // },

        // 
        
        // 本地寻找
        getChatList(){
            let array = [];
            let start = (this.page.pageNum -1)*this.page.pageSize
            let end = (this.page.pageNum)*this.page.pageSize
            if(end > this.resultList.length){
                end = this.resultList.length
            }
            let str = '';
            for (let i = start; i<end;i++) {
                array.push(this.resultList[i])
            }
            const filteredArray = array.filter(obj => obj.senderId == this.chatUserInfo.senderId && obj.isSend == 1); // 过滤出满足条件的对象数组
            str = filteredArray.map(obj => obj.messageId).join(','); // 将满足条件的字段用逗号连接成字符串
            if(str != ''){
                get(`/mpp/utils/getMessageId`).then((res)=>{
                    let obj = {
                        senderId: this.userInfo.id,
                        receiverId: this.chatUserInfo.senderId,
                        message: str,
                        messageId: res.messageId
                    }
                    let msgobj = socketObj.signed(obj)
                    if(!this.socketTask){
                        // this.$message.error('已掉线')
                        return
                    }
                    this.socketTask.send(msgobj)
                    // console.log(msgobj)
                    // 修改缓存已读
                    let objs = CircularJSON.parse(localStorage.getItem(`msgList_${this.userInfo.id}_${this.chatUserInfo.senderId}`))
                    let array = objs.msgList
                    for (let iterator of array) {
                        for (let key in filteredArray) {
                            if(iterator.messageId == filteredArray[key].messageId){
                                iterator.isSend = 2;
                            }
                        }
                    }
                    objs.msgList = array;
                    localStorage.setItem(`msgList_${this.userInfo.id}_${this.chatUserInfo.senderId}`,CircularJSON.stringify(objs))
                })
            }
            array.reverse()
            this.chatLists = [...array,...this.chatLists];
            // console.log(this.chatLists);
            this.checkPage = false
            this.quan = false
            this.reset = false
        },
        scrollHandler() {
            // console.log("??/")
            if(this.isFrist){
                // console.log(this.$refs.cc.scrollTop,this.$refs.cc.scrollHeight,this.currentTop)
                this.$refs.cc.scrollTop = this.$refs.cc.scrollHeight;
                // console.log(this.$refs.cc.scrollTop,this.$refs.cc.scrollHeight,this.currentTop)
                this.isFrist = false
            }else if(this.$refs.cc.scrollTop <= 20){
                // console.log("到顶了")
                this.checkPage = true
                this.reset = true
            }
        },
        // 修改信息状态
        changeStatus(item){
            // console.log(item)
            // let foundObject = this.chatLists.find(obj => obj.messageId == item.messageId);
            // if (foundObject) {
            //     foundObject.isSend = item.state;
            //     if(item.cc){
            //         foundObject.createTime = item.cc
            //     }
            // }
            for (const key in this.chatLists) {
                if(this.chatLists[key].messageId == item.messageId){
                    this.chatLists[key].isSend = item.state;
                    if(item.cc){
                        let obj = this.chatLists[key]
                        this.chatLists[key].createTime = item.cc
                        this.chatLists.splice(key, 1)
                        this.chatLists.push(obj)
                        break;
                    }
                }
            }
            let array = CircularJSON.parse(localStorage.getItem(`msgList_${item.senderId}_${this.chatUserInfo.senderId}`))
            let array1 = array.msgList
            // console.log(array1)
            let foundObject1 = array1.find(obj => obj.messageId == item.messageId);
            if (foundObject1) {
                foundObject1.isSend = item.state;
            }
            // console.log(foundObject1)
            array.msgList = array1;
            localStorage.setItem(`msgList_${item.senderId}_${this.chatUserInfo.senderId}`,CircularJSON.stringify(array))
        },
    }
};
</script>

<style lang="scss" scoped>
// .liao {
//     height: 70%;
// }
.jinyan{
    position: relative;
    margin-bottom: 10px;
    font-size: 12px;
    text-align: center;
    height: 16px;
    width: 100%;
    span{
        position: relative;
        padding: 0 18px;
        font-size: 12px;
        color: #fff;
        background-color: #dcdcdc;
        border-radius: 2px;
    }
}
.message {
    padding: 15px;
    height: calc(100vh - 280px);
    overflow-y: scroll;
    overflow-x: hidden;
    ul {
        list-style-type: none;
        padding-left: 0px;
        position: relative;
        li {
            margin-bottom: 15px;
            height: auto;
        }
    }
    // .time {
    //     text-align: center;
    //     margin: 7px 0;
    //     > span {
    //         display: inline-block;
    //         padding: 0 18px;
    //         font-size: 12px;
    //         color: #fff;
    //         background-color: #dcdcdc;
    //         border-radius: 2px;
    //     }
    // }
    .messageitem{
        display: flex;
        flex-direction: row;
        height: auto;
        flex-wrap: wrap;
        position: relative;
        .time{
            position: relative;
            margin-bottom: 10px;
            font-size: 16px;
            text-align: center;
            height: 18px;
            width: 100%;
            > span{
                position: relative;
                padding: 0 14px;
                font-size: 16px;
                color: #fff;
                background-color: #dcdcdc;
                border-radius: 2px;
            }
        }
        .usernameright{
            margin: 0 0;
            padding: 0 0;
            border-radius: 4px;
            line-height: 15px;
            font-size: 14px;
            color: grey;
            width: 100%;
        }
        .avtorimg{
            display: flex;
            position: relative;
            width: 84%;
            .avatar{
                border-radius: 4px;
                width: 40px;
                height: 40px;
            }
            .content{
                position: relative;
                margin-left: 8px;
                clear: both;
                font-size: 16px;
                max-width: calc(90% - 70px);
                .text{
                    white-space: pre-wrap;
                }
                .img{
                    display: inline-block;
                    height: 100px;
                    width: 100px;
                    border-radius: 5px;
                }
                .constmer{
                    display: inline-block;
                    margin-top: 0px;
                    background-color: #fafafa;
                    padding: 7px 10px;
                    word-break: break-all;
                    word-wrap: break-word;
                    // color: #fff;
                    border-radius: 3px;
                    max-width: 100%;
                    flex: 1;
                    box-sizing: border-box;
                    overflow: hidden;
                    pre{
                        white-space: pre-wrap;
                        white-space: -moz-pre-wrap;
                        white-space: -pre-wrap;
                        white-space: -o-pre-wrap;
                        word-wrap: break-word;
                    }
                }
            }
        }
    }
    .messageitem1{
        display: flex;
        flex-direction: row-reverse;
        height: auto;
        flex-wrap: wrap;
        position: relative;
        .time{
            position: relative;
            margin-bottom: 10px;
            font-size: 16px;
            text-align: center;
            height: 18px;
            width: 100%;
            > span{
                position: relative;
                padding: 0 14px;
                font-size: 16px;
                color: #fff;
                background-color: #dcdcdc;
                border-radius: 2px;
            }
        }
        .usernameright{
            margin: 0 0;
            padding: 0 0;
            border-radius: 4px;
            line-height: 15px;
            font-size: 14px;
            color: grey;
            width: 100%;
            text-align: right;
        }
        .avtorimg{
            display: flex;
            flex-direction: row-reverse;
            position: relative;
            width: 86%;
            .avatar{
                border-radius: 4px;
                width: 40px;
                height: 40px;
            }
            .content{
                position: relative;
                // margin-right: 2%;
                clear: both;
                margin-right: 8px;
                font-size: 16px;
                max-width: calc(100% - 70px);
                display: flex;
                .text{
                    white-space: pre-wrap;
                }
                .img{
                    display: inline-block;
                    height: 100px;
                    width: 100px;
                    border-radius: 5px;
                }
                .constmer{
                    display: inline-block;
                    margin-top: 0px;
                    background-color: #5FB878;
                    padding: 7px 10px;
                    word-break: break-all;
                    word-wrap: break-word;
                    color: #fff;
                    border-radius: 3px;
                    flex: 1;
                    // max-width: 90%;
                    box-sizing: border-box;
                    overflow: hidden;
                    pre{
                        white-space: pre-wrap;
                        white-space: -moz-pre-wrap;
                        white-space: -pre-wrap;
                        white-space: -o-pre-wrap;
                        word-wrap: break-word;
                    }
                }
            }
        }
    }
    // .main {
    //     position: relative;
    //     .avatar {
    //         float: left;
    //         margin: 0 10px 0 0;
    //         border-radius: 3px;
    //         width: 30px;
    //         height: 30px;
    //     }
    //     .text {
    //         display: inline-block;
    //         height:auto;
    //         word-warp: break-word;
    //         overflow-wrap: break-word;
    //         padding: 0 10px;
    //         max-width: 80%;
    //         background-color: #fafafa;
    //         border-radius: 4px;
    //         line-height: 30px;
    //         white-space: pre-wrap;
    //     }
    //     .img {
    //         display: inline-block;
    //         height: 100px;
    //         width: 100px;
    //         border-radius: 5px;
    //         // margin-top: 15px;
    //     }
    //     .usernameleft {
    //         position: absolute;
    //         left: 2px;
    //         top: -20px;
    //         margin: 0 0;
    //         padding: 0 0;
    //         border-radius: 4px;
    //         line-height: 15px;
    //         font-size: 11px;
    //         color: grey;
    //     }
    // }
    // .self {
    //     text-align: right;
    //     .avatar {
    //         float: right;
    //         margin: 0 0 0 10px;
    //         border-radius: 3px;
    //         width: 30px;
    //         height: 30px;
    //     }
    //     .text {
    //         display: inline-block;
    //         padding: 0 10px;
    //         max-width: 80%;
    //         background-color: #b2e281;
    //         text-align: left;
    //         border-radius: 4px;
    //         line-height: 30px;
    //     }
    //     .img {
    //         display: inline-block;
    //         height: 100px;
    //         width: 100px;
    //         border-radius: 5px;
    //         // margin-top: 15px;
    //     }
    //     .usernameright {
    //         //display: inline-block;
    //         position: absolute;
    //         right: 0 !important;
    //         top: -20px;
    //         margin: 0 0;
    //         padding: 0 0;
    //         width: 200px;
    //         line-height: 15px;
    //         font-size: 11px;
    //         color: grey;
    //     }
    // }
}
</style>
